export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/auth/login-ico-sns-google-abb03d27c5764dce9bb59f95ca5c8602.svg";